import Vue from "vue";
import VueRouter from "vue-router";
import Success from "./components/Success.vue";
import NotFound from "./components/Notfound.vue";
import ClaimsReporting from "./components/ClaimsReporting.vue";
import Review from "./components/ReviewDetails.vue";
import ValCode from "./components/ValidateCode.vue";
import eclaim from "./components/eclaim.vue";

// Load on fly example
//const NotFound = () => System.import('./components/Notfound.vue')

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    { path: "/success/:id", name: "completed", component: Success },
    { path: "/eclaim", name: "eclaim", component: eclaim },
    { path: "/review/:id", name: "review", component: Review },
    { path: "/code", name: "code", component: ValCode },
    { path: "/", component: ClaimsReporting },
    { path: "*", name: "notfound", component: NotFound }
  ]
});

export default router;
